export const intersect = function (array1: String[], array2: String[]) {
  return array1.filter((a1) => array2.includes(a1));
};
